import { BenefitDTO, BenefitDTOBenefitEnum, CouponBenefitDetailsDTO, CouponsV2BenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class CouponsV2BenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    // Hide coupons V2 tile if active coupons V1 tile is shown
    return (
      activeBenefit.benefit === BenefitDTOBenefitEnum.CouponsV2 &&
      activeBenefits.some(
        benefit => benefit.benefit === BenefitDTOBenefitEnum.Coupons && (benefit.details as CouponBenefitDetailsDTO).currentlyActivated,
      )
    );
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsCouponsV2 = activeBenefit.details as CouponsV2BenefitDetailsDTO;
    const totalAmountLeftV2 =
      detailsCouponsV2.totalAmountLeft + detailsCouponsV2.availableTokens.reduce((sum, { amount }) => sum + amount, 0);

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/couponsV2',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.description.couponsAvailable`,
      descriptionValues: { count: totalAmountLeftV2 },
      benefitProgress: detailsCouponsV2.availableTokens.length === 0 ? 100 : 0,
    };
  }
}
